// extracted by mini-css-extract-plugin
module.exports = {"tutorial-modal":"Ift1vDrJ"};